import {Observable} from 'rxjs';
import {Store} from '@ngxs/store';
import {Component, Input, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, TemplateRef, OnChanges} from '@angular/core';
import {EntityListHeaderParams} from 'app/blocks/entity/entity-list-header-params';
import {DiSearchBarComponent} from 'app/common/di-search-bar/di-search-bar.component';
import {TranslateService} from '@ngx-translate/core';
import {Principal} from 'app/core/auth/principal.service';
import {take} from 'rxjs/operators';

@Component({
    // Angular 22 defaults to OnPush; Eager preserves the previous behaviour.
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'di-list-page-header',
    templateUrl: './di-list-page-header.component.html',
    styleUrls: ['./di-list-page-header.component.scss'],
    standalone: false
})
export class DiListPageHeaderComponent implements OnInit, OnChanges {
    @Input()
    headerParams: EntityListHeaderParams;

    @ViewChild(DiSearchBarComponent, {static: true})
    public readonly search: DiSearchBarComponent;

    @Input()
    extraButtonTemplate: TemplateRef<any>;

    @Input()
    extraInfoTemplate: TemplateRef<any>;

    @Input() showSearchBar = true;

    selectedIds$: Observable<number[]>;
    groupActionProcessing$: Observable<boolean>;

    @Input()
    headingKey = '';

    addButtonTextKey: string;
    isCustomerUser = false;

    constructor(
        public readonly store: Store,
        public translationService: TranslateService,
        private changeDetectorRef: ChangeDetectorRef,
        _principal: Principal
    ) {
        this.isCustomerUser = _principal.isUserCustomer();
    }

    ngOnInit(): void {
        this.refreshHeader();
    }

    ngOnChanges(): void {
        this.refreshHeader();
    }

    getCurrentPageSelectedIds = () => {
        const listView = this.store.selectSnapshot((state) => state.entities[this.headerParams.resource.name].listView);
        const entityList: any[] = listView.entityList;
        const selectedIds: number[] = listView.selectedIds;
        return entityList.map((entity) => entity.id).filter((id) => selectedIds.includes(id));
    };

    refreshHeader() {
        let shouldRunDetection = false;
        if (!this.headerParams.isConditionalHeader) {
            if (this.headingKey == '') {
                this.translationService.get(`${this.headerParams.resource.name}.pages.list.heading`).subscribe((data) => (this.headingKey = data));
                shouldRunDetection = true;
            }
        } else {
            if (this.headingKey == '') {
                this.translationService.get(`${this.headerParams.resource.name}.pages.list.headings`).subscribe((data) => {
                    this.headingKey = data[this.headerParams.currentHeaderIndex];
                });
            }
        }
        this.addButtonTextKey = `${this.headerParams.resource.name}.pages.list.buttons.add`;
        this.selectedIds$ = this.store.select((state) => state.entities[this.headerParams.resource.name].listView.selectedIds);
        this.groupActionProcessing$ = this.headerParams.groupActionProcessing;

        if (shouldRunDetection) {
            this.changeDetectorRef.markForCheck();
        }
    }

    executeAction(act: any): void {
        act.enabled$.pipe(take(1)).subscribe((enabled: boolean) => {
            if (enabled) {
                if (act.action != null) {
                    act.action();
                }
            }
        });
    }
}
